'use client';
import React, { useRef } from 'react';
import ContactForm from '@/components/common/ygen/sections/contact-form/ContactForm';
import CloseButtonYgen from '@/components/common/ui/buttons/CloseButtonYgen';
import { StyledQuote } from '@/components/common/ygen/sections/quote/quote.style';

const Quote = ({ data, onclick , show, interest}) => {


	const handleClick = () => {
		if (typeof onclick === "function") {
			onclick();
			window.history.pushState("", document.title, window.location.pathname + window.location.search);

		}
	};


	return (
		<StyledQuote className="Quote" data-scroll-section>
			<ContactForm form_id={data ? data : 'get-a-quote'} interest={interest}/>
			<div className="close-button-ygen" onClick={handleClick}>
				<CloseButtonYgen active={show} color={'#152637'}/>
			</div>
		</StyledQuote>
	);
};



export default React.memo(Quote);
